/**
 * Inc / ex VAT switch.
 *
 * Both prices are rendered server-side by snippets/price.liquid; this only
 * flips <html data-vat> and remembers the choice. It never does arithmetic.
 * The first value is applied by an inline script in layout/theme.liquid
 * before first paint, so there is no flash of the wrong price.
 */
(function () {
  'use strict';

  var KEY = 'eracco:vat';
  var root = document.documentElement;

  function apply(mode) {
    root.setAttribute('data-vat', mode);
    try { localStorage.setItem(KEY, mode); } catch (e) { /* private mode: session only */ }
    document.querySelectorAll('[data-vat-toggle] button[data-vat-mode]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(btn.dataset.vatMode === mode));
    });
    document.dispatchEvent(new CustomEvent('eracco:vatchange', { detail: { mode: mode } }));
  }

  function init() {
    apply(root.getAttribute('data-vat') === 'ex' ? 'ex' : 'inc');
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vat-toggle] button[data-vat-mode]');
      if (!btn) return;
      apply(btn.dataset.vatMode);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
